<template>
  <div>
    <PageHeader :breadcrumRoutes="routes_pageheader" title="Cobranzas" />

    <a-card>
      <a-typography-title :level="4" class="text-gray-8 mb-0">
        Lista de cobranzas
      </a-typography-title>

      <CollectionDetailTable class="mt-3" />
    </a-card>
  </div>
</template>

<script setup>
import PageHeader from '@/components/page-header.vue';
import CollectionDetailTable from '@/components/dashboard/collection-detail-table.vue';

const routes_pageheader = [
  {
    breadcrumbName: 'Cobranzas'
  }
];
</script>
